module.exports = __webpack_public_path__ + "img/logo.397c8b6c.png";